import React from 'react';

import { FallbackMessage } from './MissingTimeSlotsFallback.styled';

import { ContactPatientNavigatorLink } from '../ContactPatientNavigatorLink';

export const DEFAULT_FALLBACK = (
  <FallbackMessage>
    <h2>There are no available time slots for this appointment.</h2>
    <p>Please reach out for scheduling options.</p>
    <p>
      <ContactPatientNavigatorLink /> or call <a href="tel://855-563-2639">855-563-2639</a>
    </p>
  </FallbackMessage>
);
